/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DepartmentDTO,
    DepartmentDTOFromJSON,
    DepartmentDTOFromJSONTyped,
    DepartmentDTOToJSON,
} from './DepartmentDTO';
import {
    Role,
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
} from './Role';

/**
 * 
 * @export
 * @interface AcademicUserDTO
 */
export interface AcademicUserDTO {
    /**
     * 
     * @type {string}
     * @memberof AcademicUserDTO
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof AcademicUserDTO
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AcademicUserDTO
     */
    cursId?: number;
    /**
     * 
     * @type {string}
     * @memberof AcademicUserDTO
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AcademicUserDTO
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AcademicUserDTO
     */
    image?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AcademicUserDTO
     */
    departmentId?: string;
    /**
     * 
     * @type {DepartmentDTO}
     * @memberof AcademicUserDTO
     */
    department?: DepartmentDTO;
    /**
     * 
     * @type {Array<Role>}
     * @memberof AcademicUserDTO
     */
    roles?: Array<Role> | null;
}

export function AcademicUserDTOFromJSON(json: any): AcademicUserDTO {
    return AcademicUserDTOFromJSONTyped(json, false);
}

export function AcademicUserDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcademicUserDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'cursId': !exists(json, 'cursId') ? undefined : json['cursId'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'image': !exists(json, 'image') ? undefined : json['image'],
        'departmentId': !exists(json, 'departmentId') ? undefined : json['departmentId'],
        'department': !exists(json, 'department') ? undefined : DepartmentDTOFromJSON(json['department']),
        'roles': !exists(json, 'roles') ? undefined : (json['roles'] === null ? null : (json['roles'] as Array<any>).map(RoleFromJSON)),
    };
}

export function AcademicUserDTOToJSON(value?: AcademicUserDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'cursId': value.cursId,
        'email': value.email,
        'phone': value.phone,
        'image': value.image,
        'departmentId': value.departmentId,
        'department': DepartmentDTOToJSON(value.department),
        'roles': value.roles === undefined ? undefined : (value.roles === null ? null : (value.roles as Array<any>).map(RoleToJSON)),
    };
}

